import {Component, EventEmitter, inject, Output} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {StripeService} from "../../../core/services/stripe.service";
import {CouponService} from "../../../core/services/coupon.service";
import {Coupon} from "../../../core/models/coupon.model";

@Component({
  selector: 'app-onboarding-coupon-form',
  templateUrl: './coupon-form.component.html',
  styleUrls: ['./coupon-form.component.scss']
})
export class CouponFormComponent {

  @Output() couponSelected = new EventEmitter<Coupon>();

  readonly #couponService = inject(CouponService);
  private _couponForm!: FormGroup;
  private _errorMessage: string | null = null;
  private _successMessage: string | null = null;

  constructor(private readonly stripeService: StripeService) {
    this._couponForm = new FormGroup({
      name: new FormControl(''),
    });
  }

  get couponForm(): FormGroup {
    return this._couponForm;
  }

  get errorMessage(): string | null {
    return this._errorMessage;
  }

  get successMessage(): string | null {
    return this._successMessage;
  }

  public submit() {
    if (this._couponForm.valid) {
      this._errorMessage = null;
      this._successMessage = null;
      let couponName = this.couponForm.controls['name'].value;
      this.#couponService.getCouponByName(couponName).subscribe({
        next: (response) => {
          this.couponSelected.emit(response);
          this._successMessage = "Votre code de réduction " + couponName + " a été appliqué avec succès !"
        },
        error: (error) => {
          this._errorMessage = "Le code de réduction est invalide ou a expiré."
        }
      })
    }
  }
}
